import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/group-setup/initial-setup.md?raw';

const GroupSetupInitial: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default GroupSetupInitial;
